<script setup lang="ts">
import type { SightlineArtCell } from "@/backend/natsstubs/sightline/models";

import SightlineTruncatedText from "./SightlineTruncatedText.vue";

defineProps<{ cell: SightlineArtCell }>();
</script>

<template>
  <SightlineTruncatedText :text="cell.label" icon="general/art" />
</template>
